var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgForestStar = function SvgForestStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#169B62",
    d: "m24.787 9.09-7.442-1.082-3.326-6.744a.93.93 0 0 0-.425-.425.94.94 0 0 0-1.258.425L9.01 8.008 1.568 9.09a.936.936 0 0 0-.519 1.6l5.384 5.25-1.272 7.411a.936.936 0 0 0 1.36.988l6.657-3.5 6.656 3.5a.936.936 0 0 0 1.36-.988l-1.272-7.412 5.384-5.25a.94.94 0 0 0 .272-.536.935.935 0 0 0-.791-1.064"
  })));
};
export { SvgForestStar as ReactComponent };
export default __webpack_public_path__ + "images/forest-star.svg";